import { useAuth0 } from '@auth0/auth0-react';
import { BlankScreen } from '@strata/react-page-templates';
import { Outlet, useLocation } from 'react-router';

import { Header } from 'components/header/Header';
import { LOGIN_REDIRECT_KEY } from 'services/constants';
import { AppRoutes } from 'services/routes';

/** Routes that header is hidden on */
const NoHeaderRoutes: string[] = [
    AppRoutes.termsOfUse,
    AppRoutes.privacyPolicy,
    AppRoutes.updatesHistory,
];

/**
 * Component to determine if a user is authenticated and
 * if they are allowed to visit the page they navigated to.
 *
 * If they are: they proceed to the page
 * If not: they are redirected to the login page.
 */
export const RequireAuth = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const location = useLocation();

    if (!isAuthenticated) {
        sessionStorage.setItem(LOGIN_REDIRECT_KEY, location.pathname);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loginWithRedirect();
        return <BlankScreen />;
    }

    return (
        <>
            {!NoHeaderRoutes.includes(location.pathname) && <Header />}
            <Outlet />
        </>
    );
};
